/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from "react";

import { useTheme } from "@material-ui/core/styles";

import {
  useNotify,
  ArrayField,
  Datagrid,
  FunctionField,
  NumberField,
  TextField,
} from "react-admin";

import { logError } from "../../../utils/appUtils";
import { UnitOptions } from "../../../utils/constants";
import { ServiceStatusIcon } from "./ServiceStatusIcon";
import { fetchServices } from "./ServiceUtils";

const normalizeName = (name) => name?.trim().toLowerCase() || "";

export const ServicesPeak = ({ record, resource, highlightNames = [] }) => {
  const notify = useNotify();
  const theme = useTheme();
  const [serviceRates, setServiceRates] = useState(null);
  const highlightSet = useMemo(() => {
    return new Set(highlightNames.map(normalizeName));
  }, [highlightNames]);
  const hasHighlights = highlightSet.size > 0;

  useEffect(() => {
    if (record?.id) {
      const fetchData = async () => {
        try {
          const activeServices = await fetchServices(record.id, true, true);
          setServiceRates({ items: activeServices });
        } catch (error) {
          logError("services:ServicesPeak:fetchServiceData", error, notify);
        }
      };
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record]);

  const unitsWithRates = useMemo(() => {
    if (!serviceRates?.items) return [];
    const units = {};
    serviceRates.items.forEach((service) => {
      UnitOptions.forEach((unit) => {
        const rate = service[unit.column];
        if (rate != null && rate !== 0) {
          units[unit.id] = unit;
        }
      });
    });
    return Object.values(units);
  }, [serviceRates]);

  if (!serviceRates?.items?.length) {
    return <p>No active services available.</p>;
  }

  return (
    <ArrayField
      source="items"
      record={serviceRates}
      resourceresource={resource}
    >
      <Datagrid
        rowStyle={(row) =>
          highlightSet.has(normalizeName(row?.name))
            ? { backgroundColor: theme.palette.action.selected }
            : {}
        }
      >
        <ServiceStatusIcon source="status" label="" sortable={false} />
        <TextField source="name" label="Service" sortable={false} />
        {unitsWithRates.map((unit) => (
          <NumberField
            key={unit.id}
            source={unit.column}
            label={unit.id}
            options={{
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }}
            sortable={false}
          />
        ))}
        {hasHighlights && (
          <FunctionField
            label="Overlap"
            render={(row) =>
              highlightSet.has(normalizeName(row?.name)) ? "Replace" : ""
            }
          />
        )}
      </Datagrid>
    </ArrayField>
  );
};
